export default class WorkItemRelated {
  id: string;

  title: string;

  workItemNumber: number;

  lastUpdate: string;

  statusLabel: string;

  error: string;

  workItemTypeId: string;

  constructor(obj: any) {
    this.id = obj.id;
    this.title = obj.title;
    this.workItemNumber = obj.workItemNumber;
    this.lastUpdate = obj.lastUpdate;
    this.statusLabel = obj.statusLabel;
    this.error = obj.error || '';
    this.workItemTypeId = obj.workItemTypeId;
  }

  get numberAndTitle() {
    return `${this.workItemNumber} - ${this.title}`;
  }

  public static of(obj: any): WorkItemRelated {
    return new WorkItemRelated(obj);
  }

  public static ofList(obj: any): WorkItemRelated[] {
    return obj.map(this.of);
  }
}
